import { GetDocumentsByStudioParams } from './getDocumentsByStudio.types';

export function makeGetDocumentsByStudioParams(
  params: GetDocumentsByStudioParams,
) {
  const { manufacturerId = [] } = params;
  return {
    q: String(params.q ?? ''),
    limit: String(params.limit),
    page: String(params.page),
    sort: String(params.sort ?? ''),
    direction: String(params.direction ?? ''),
    manufacturerId: manufacturerId.join(','),
    source: String(params.source ?? ''),
  };
}
